import React from "react";
import SVG from "components/base/SVG";
import classNames from "classnames";
import { useSelector } from 'react-redux';
import { selectUserProfile } from "data/user/selectors";

import { messages } from "./utils";

import css from "./style.scss";

const ICONS = {
  DEFAULT: "xCircle",
  ERROR: "xCircleError",
  CORRECT: "checkCircle",
};

const InfoMessage = ({ password, email, fname, lname }) => {
  const [isError,setError] = React.useState(false);
  const immutableUserProfile     = useSelector(selectUserProfile);
  const selectUserProfileSection = immutableUserProfile ? immutableUserProfile.toJS() : {}; 

  React.useEffect(()=>{
    let isError = false;
    messages.forEach(each => {
      const state = each.fn(password);
      if(state === "ERROR") isError = true;
    });
    setError(isError);
  }, [password])
  return (
    <div>
      <p 
        className={classNames(css.clsInfoTitle)}
        style={{
          color: isError && "#CA1551"
        }}
      >
        Password must meet the following requirements :
      </p>
      {messages.map((each, index) => {
        const state = each.fn(password,  email || selectUserProfileSection?.username, fname || selectUserProfileSection?.firstName, lname || selectUserProfileSection?.lastName);
        const icon = ICONS[state];
        return (
          <p 
            key={index} 
            className={classNames(css.clsInfoMessage)}>
            <SVG icon={icon} className={classNames(css.clsInfoIcon)} />
            {each.message}
          </p>
        );
      })}
    </div>
  );
}
export default InfoMessage